module.exports = __webpack_public_path__ + "static/img/176_TO8_2012.8744fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/176_TO8_2012.jpg
// module id = GiOV
// module chunks = 0